import { Component } from "react";
import { ScreenInvalidListenerError } from "../../errors";

export default class Screen extends Component {
    state = { width: window.innerWidth, height: window.innerHeight };
    static setResizeListener = false;
    static resizeListeners = [];

    constructor(props) {
        super(props);
        if (!Screen.setResizeListener) {
            window.addEventListener("resize", (e) => {
                Screen.resizeListeners.forEach(listener => listener(e));
                let viewportType = Screen.getViewportType();
                if (viewportType !== Screen.currentViewportType) {
                    Screen.currentViewportType = viewportType;
                    Screen.viewportTypeListeners.forEach(listener => listener(viewportType));
                }
            });
        }
    }

    static VIEWPORT_TYPES = {
        CELLPHONE_SMALL: 0,
        CELLPHONE_MEDIUM: 1,
        CELLPHONE_LARGE: 2,
        TABLET: 3,
        NOTEBOOK: 4,
        NOTEBOOK_LARGE: 5,
        DESKTOP: 6,
        _4K: 7,
    };

    static currentViewportType = -1;
    static viewportTypeListeners = [];

    static isCellphoneSmall() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES.CELLPHONE_SMALL;
    }

    static isCellphoneMedium() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES.CELLPHONE_MEDIUM;
    }

    static isCellphoneLarge() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES.CELLPHONE_LARGE;
    }

    static isTablet() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES.TABLET;
    }

    static isNotebook() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES.NOTEBOOK;
    }

    static isNotebookLarge() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES.NOTEBOOK_LARGE;
    }
    
    static isDesktop() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES.DESKTOP;
    }

    static is4K() {
        return Screen.currentViewportType === Screen.VIEWPORT_TYPES._4K;
    }

    static getViewportType() {
        if (window.innerWidth <= 320) return Screen.VIEWPORT_TYPES.CELLPHONE_SMALL;
        if (window.innerWidth <= 375) return Screen.VIEWPORT_TYPES.CELLPHONE_MEDIUM;
        if (window.innerWidth <= 425) return Screen.VIEWPORT_TYPES.CELLPHONE_LARGE;
        if (window.innerWidth <= 768) return Screen.VIEWPORT_TYPES.TABLET;
        if (window.innerWidth <= 1024) return Screen.VIEWPORT_TYPES.NOTEBOOK;
        if (window.innerWidth <= 1440) return Screen.VIEWPORT_TYPES.NOTEBOOK_LARGE;
        if (window.innerWidth <= 1920) return Screen.VIEWPORT_TYPES.DESKTOP;
        return Screen.VIEWPORT_TYPES._4K;
    }

    static addViewportTypeListener(listener) {
        if (!listener || listener.constructor !== Function) throw new ScreenInvalidListenerError("The listener must be a function.");
        Screen.viewportTypeListeners.push(listener);
    }

    static removeViewportTypeListener(listener) {
        let index = Screen.viewportTypeListeners.findIndex(_listener => _listener === listener);
        if (index < 0) throw new ScreenInvalidListenerError("Could not find the given listener to remove.");
        Screen.viewportTypeListeners.splice(index, 1);
    }

    static addResizeListener(listener) {
        if (!listener || listener.constructor !== Function) throw new ScreenInvalidListenerError("The listener must be a function.");
        Screen.resizeListeners.push(listener);
    }

    static removeResizeListener(listener) {
        let index = Screen.resizeListeners.findIndex(_listener => _listener === listener);
        if (index < 0) throw new ScreenInvalidListenerError("Could not find the given listener to remove.");
        Screen.resizeListeners.splice(index, 1);
    }

    updateScreenSize = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentDidMount() {
        Screen.addResizeListener(this.updateScreenSize);
    }

    componentWillUnmount() {
        Screen.removeResizeListener(this.updateScreenSize);
    }

    render() {
        let { cellphone, tablet, notebook, desktop, xs, sm, md, lg, xl } = this.props;

        if (xs && this.state.width < 320) return null;
        else if ((cellphone || sm) && this.state.width < 425) return null;
        else if ((tablet || md) && this.state.width < 768) return null;
        else if ((notebook || lg) && this.state.width < 1024) return null;
        else if ((desktop || xl) && this.state.width < 1920)  return null;

        return this.props.children;
    }
}
